import dayjs from 'dayjs';
import { MedplumClient } from '@medplum/core';
import { Period, Reference } from '@medplum/fhirtypes';
import { alert } from './alert';
import { fetchBot } from './services';

export const changeResourcePriority = async (
  medplum: MedplumClient,
  reference: Reference,
  priority: 'urgent' | undefined
) => {
  try {
    await fetchBot(medplum, 'change-communication-priority', {
      communicationRef: reference,
      priority,
    });
  } catch (error) {
    alert.error({
      title: "Couldn't update priority",
      message: error instanceof Error ? error.message : 'Unknown error',
    });
  }
};

export function getPriorityStatus(
  priority?: 'routine' | 'urgent' | 'asap' | 'stat',
  executionPeriod?: Period
): 'normal' | 'urgent' | 'overdue' {
  if (priority === 'urgent') {
    return isTaskEndTimeOverdue(executionPeriod) ? 'overdue' : 'urgent';
  }

  return 'normal';
}

const isTaskEndTimeOverdue = (executionPeriod?: Period): boolean => {
  if (!executionPeriod?.end) {
    return false;
  }
  // DAY granularity, matching the due-date canon and the other inbox
  // helpers: due today is due, not overdue. Exact-timestamp comparison made
  // the inbox badge contradict the patient tab for tasks due today.
  return dayjs(executionPeriod.end).isBefore(dayjs(), 'day');
};
